import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../Components/Ui/Card';
import Button from '../../../Components/Ui/Button';
import { productHistoryData } from '../../../Data/Dummydata';
import { ArrowLeft } from 'lucide-react';

const History = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const filteredHistory = productHistoryData.filter((entry) => String(entry.productId) === id);

  return (
    <div className="max-w-6xl mx-auto">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-2xl font-bold pl-4">Product Modification History</h2>
        <Button onClick={() => navigate(-1)}>
          <ArrowLeft size={16} />
          Back to Product
        </Button>
      </div>

      {filteredHistory.length === 0 ? (
        <Card className="p-6 text-center">
          <p className="text-gray-500">No history available for this product.</p>
        </Card>
      ) : (
        <div className="space-y-4">
          {filteredHistory.map((entry, index) => (
            <Card key={index} className="p-6 rounded-xl shadow-md">
              <div className="flex justify-between items-center mb-2">
                <h3 className="font-semibold text-lg tertiary-text-color">
                  {new Date(entry.date).toLocaleDateString()}
                </h3>
                <span className="text-sm text-gray-500">Modified by: {entry.modifiedBy}</span>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm mt-4">
                {entry.changes.map((change, i) => (
                  <div key={i} className="bg-gray-50 p-4 border rounded-lg">
                    <p className="font-medium text-secondary mb-1">{change.field}</p>
                    <p className="text-red-600">
                      Before: <span className="line-through">{change.before}</span>
                    </p>
                    <p className="text-green-600">After: {change.after}</p>
                  </div>
                ))}
              </div>

              {entry.note && (
                <p className="mt-4 text-sm italic text-gray-600">Note: {entry.note}</p>
              )}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default History;
